<template>
  <div class="guidePageBtn" @mousedown="dragMove" ref="guidePageBtn">
    <div class="guideBtn">
      <div class="iconfont icon-icon2" />
      <span>操作引导</span>
    </div>
    <div class="bubbleBox" v-show="bubbleBoxShow">
      <span>看完，还想看？点它可以重复显示哦~</span>
      <div>
        <span @mouseup.stop="bubbleBoxClick">我知道了</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bubbleBoxShow: false,
      bubbleBoxTimer: () => {}
    };
  },
  methods: {
    dragMove (e) {
      if (this.bubbleBoxShow) return;
      let odiv = this.$refs.guidePageBtn;
      // 算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      let oldEleLeft = odiv.offsetLeft;
      let oldEleTop = odiv.offsetTop;
      document.onmousemove = (e) => {
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的实际位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        odiv.style.left = left + 'px';
        odiv.style.top = top + 'px';
      };
      document.onmouseup = (e) => {
        let eleLeft = odiv.offsetLeft;
        let eleTop = odiv.offsetTop;
        if (oldEleLeft === eleLeft && oldEleTop === eleTop) {
          this.$emit('guideBtnHandle');
        }
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    bubbleBoxClick () {
      clearTimeout(this.bubbleBoxTimer);
      this.bubbleBoxShow = false;
    },
    bubbleTimerStart () {
      this.bubbleBoxShow = true;
      this.$refs.guidePageBtn.style.left = 'auto';
      this.$refs.guidePageBtn.style.right = '14px';
      this.$refs.guidePageBtn.style.top = '50%';
      this.bubbleBoxTimer = setTimeout(() => {
        this.bubbleBoxShow = false;
      }, 5000);
    }
  }
};
</script>

<style lang="scss" scoped>
.guidePageBtn{
  width: 80px;
  height: 80px;
  position: fixed;
  right: 14px;
  top: 50%;
  z-index: 120;
  >.bubbleBox{
    width: 370px;
    border-radius: 4px;
    box-shadow: 0px 0px 16px rgba(24, 64, 122, 0.24);
    background: #3384FE;
    position: absolute;
    right: 110px;
    top: 0;
    color: #ffffff;
    padding: 20px 16px;
    line-height: 20px;
    z-index: 121;
    >div{
      margin-top: 20px;
      text-align: right;
      cursor: pointer;
    }
    &:after{
      content: '';
      display: block;
      position: absolute;
      right: -26px;
      top: 20px;
      width: 0;
      border-top: 10px solid transparent;
      border-right: 18px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 16px solid #3384FE;
    }
  }
  >.guideBtn{
    width: 80px;
    height: 80px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #DEE1E7;
    box-shadow: 0 2px 12px 0 rgba(63, 74, 88, 0.1);
    text-align: center;
    color: #424C57;
    cursor: pointer;
    padding: 14px 0;
    box-sizing: border-box;
    >div{
      font-size: 24px;
    }
    >span{
      font-size: 12px;
      line-height: 16px;
    }
    &:hover{
      background: #17A58A;
      color: #ffffff;
    }
  }
}
</style>
